"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTokenClient = void 0;
const z = require("zod");
const botframework_schema_1 = require("botframework-schema");
/**
 * Client for access user token service.
 */
class UserTokenClient {
    /**
     * Helper function to create the Base64 encoded token exchange state used in getSignInResource calls.
     *
     * @param appId The appId to include in the token exchange state.
     * @param connectionName The connectionName to include in the token exchange state.
     * @param activity The [Activity](xref:botframework-schema.Activity) from which to derive the token exchange state.
     * @returns Base64 encoded token exchange state.
     */
    static createTokenExchangeState(appId, connectionName, activity) {
        z.object({
            appId: z.string(),
            connectionName: z.string(),
            activity: z.record(z.unknown()),
        }).parse({
            appId,
            connectionName,
            activity,
        });
        const tokenExchangeState = {
            connectionName,
            conversation: botframework_schema_1.ActivityEx.getConversationReference(activity),
            relatesTo: activity.relatesTo,
            msAppId: appId,
        };
        return Buffer.from(JSON.stringify(tokenExchangeState)).toString('base64');
    }
}
exports.UserTokenClient = UserTokenClient;
//# sourceMappingURL=userTokenClient.js.map